import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M12 10.6 17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4 6.4 5l5.6 5.6z",
		clipRule: "evenodd"
	})
});
export default SvgCloseLarge;
